module.exports = __webpack_public_path__ + "img/Unidad8-3.d05fa8b2.png";